module.exports = __webpack_public_path__ + "img/csfw_icon3.effc105c.png";